export const TagCard = ({ tag, className = "" }) => {
  return (
    <span className={`bg-[#F5F5F5] hover:bg-gray-200 text-black px-2 py-1 rounded-lg text-sm transition-colors duration-200 cursor-pointer flex items-center max-h-12`}>
      {Boolean(tag?.img) && <img src={tag.img} alt="Tag icon" className={`mr-1.5 object-contain ${className}`} />}
      {tag.name}
    </span>
  )
}